export var assign = require("lodash/assign");
export var capitalize = require("lodash/capitalize");
export var cloneDeep = require("lodash/cloneDeep");
export var compact = require("lodash/compact");
export var deburr = require("lodash/deburr");
export var filter = require("lodash/filter");
export var find = require("lodash/find");
export var flow = require("lodash/flow");
export var get = require("lodash/get");
export var kebabCase = require("lodash/kebabCase");
export var map = require("lodash/map");
export var omitBy = require("lodash/omitBy");
export var orderBy = require("lodash/orderBy");
export var pickBy = require("lodash/pickBy");
export var range = require("lodash/range");
export var round = require("lodash/round");
export var trimEnd = require("lodash/trimEnd");
export var truncate = require("lodash/truncate");
export var upperFirst = require("lodash/upperFirst");
var lodash = {
    assign: assign,
    capitalize: capitalize,
    cloneDeep: cloneDeep,
    compact: compact,
    deburr: deburr,
    filter: filter,
    find: find,
    flow: flow,
    get: get,
    kebabCase: kebabCase,
    map: map,
    omitBy: omitBy,
    orderBy: orderBy,
    pickBy: pickBy,
    range: range,
    round: round,
    trimEnd: trimEnd,
    truncate: truncate,
    upperFirst: upperFirst,
};
export default lodash;



//////////////////
// WEBPACK FOOTER
// ./app/shared/utils/lodash.ts
// module id = cRoh
// module chunks = 2 3 4